<template>
  <div>
    <h1 class="page-header">{{ $t('purchaseorder.purchaseorder') }}</h1>
    <ts-card>
      <ts-card-wrapper>
        <div class="row">
          <div class="col-md-12">
            <div class="form-group row">
              <label class="col-form-label col-md-1 required">{{
                $t('purchaseorder.supplier')
              }}</label>
              <div class="col-md-3">
                <select
                  v-model="model.supplier_id"
                  class="form-control"
                  :class="{ 'is-invalid': errors.has('supplier_id') }"
                >
                  <option value="">{{ $t('select') }}</option>
                  <option
                    v-for="(supplier, index) in suppliers"
                    :key="index"
                    :value="supplier.supplier_id"
                  >
                    {{ supplier.supplier_name_en }}
                  </option>
                </select>
                <div class="invalid-feedback" v-if="errors.has('supplier_id')">
                  {{ errors.first('supplier_id') }}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <div class="form-group row">
              <label class="col-form-label col-md-1 required">{{
                $t('purchaseorder.date')
              }}</label>
              <div class="col-md-3">
                <ts-date-picker-input
                  v-model="model.po_date"
                ></ts-date-picker-input>
                <div class="validate" v-if="errors.has('po_date')">
                  {{ errors.first('po_date') }}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <table class="table ui-table table-hover">
              <thead>
                <tr>
                  <th style="width:20%">{{ $t('purchaseorder.barcode') }}</th>
                  <th>{{ $t('purchaseorder.product') }}</th>
                  <th style="width:15%">{{ $t('purchaseorder.uom') }}</th>
                  <th style="width:15%" class="text-center">
                    {{ $t('purchaseorder.quantity') }}
                  </th>
                  <th style="width: 2%" class="text-center">
                    <a href="" class="text-primary">
                      <i class="fas fa-spinner spin" v-if="ready"></i>
                      <i
                        class="fa fa-plus"
                        v-else
                        @click.prevent="addNewRow"
                      ></i>
                    </a>
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item, index) in model.sub_item_list" :key="index">
                  <td>
                    <select
                      class="form-control only-border-bottom"
                      v-model="item.barcode"
                      @change="barcodeChange(item)"
                    >
                      <option value="">{{ $t('select') }}</option>
                      <option
                        v-for="(product, index) in products"
                        :key="index"
                        :value="product.barcode"
                      >
                        {{ product.barcode }}
                      </option>
                    </select>
                  </td>
                  <td>
                    <select
                      class="form-control only-border-bottom"
                      :class="{
                        'is-invalid': errors.has(
                          'sub_item_list.' + index + '.product_id'
                        )
                      }"
                      v-model="item.product_id"
                      @change="productChange(item)"
                    >
                      <option value="">{{ $t('select') }}</option>
                      <option
                        v-for="(product, index) in products"
                        :key="index"
                        :value="product.product_id"
                      >
                        {{ product.product_name_en }}
                      </option>
                    </select>
                    <div
                      class="invalid-feedback"
                      v-if="
                        errors.has('sub_item_list.' + index + '.product_id')
                      "
                    >
                      {{
                        errors.first('sub_item_list.' + index + '.product_id')
                      }}
                    </div>
                  </td>
                  <td>
                    <select
                      class="form-control only-border-bottom"
                      :class="{
                        'is-invalid': errors.has(
                          'sub_item_list.' + index + '.uom_id'
                        )
                      }"
                      v-model="item.uom_id"
                    >
                      <option value="">{{ $t('select') }}</option>
                      <option
                        v-for="(uom, index) in uomGetter(item)"
                        :key="index"
                        :value="uom.uom_id"
                        >{{ uom.uom_name_en }}</option
                      >
                    </select>
                    <div
                      class="invalid-feedback"
                      v-if="errors.has('sub_item_list.' + index + '.uom_id')"
                    >
                      {{ errors.first('sub_item_list.' + index + '.uom_id') }}
                    </div>
                  </td>
                  <td>
                    <input
                      type="number"
                      v-model="item.qty"
                      class="form-control only-border-bottom"
                      :class="{
                        'is-invalid': errors.has(
                          'sub_item_list.' + index + '.qty'
                        )
                      }"
                    />
                    <div
                      class="invalid-feedback"
                      v-if="errors.has('sub_item_list.' + index + '.qty')"
                    >
                      {{ errors.first('sub_item_list.' + index + '.qty') }}
                    </div>
                  </td>
                  <td>
                    <a
                      href="#"
                      class="text-danger"
                      @click.prevent="removeRow(item)"
                    >
                      <i class="fa fa-trash"></i>
                    </a>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div class="row mt-4">
          <div class="col-md-11"></div>
          <div class="col-md-1 text-right ts-whitespace-no-wrap">
            <ts-checkbox v-model="model.preview">{{
              $t('purchaseorder.previewPdfFile')
            }}</ts-checkbox>
          </div>
        </div>
        <div class="row mt-4">
          <div class="col-md-12 text-right">
            <ts-button
              v-if="model.sub_item_list.length > 0"
              class="btn-primary mr-2"
              @click.prevent="store"
              :waiting="saving"
              >{{ $t('save') }}</ts-button
            >
            <ts-button
              v-if="model.sub_item_list.length > 0"
              class="btn-primary mr-2"
              @click.prevent="saveNew"
              :waiting="saving_new"
              >{{ $t('saveAddNew') }}</ts-button
            >
            <ts-button
              class="btn-default"
              @click="$router.push({ name: 'purchase-order' })"
              >{{ $t('cancel') }}</ts-button
            >
          </div>
        </div>
      </ts-card-wrapper>
    </ts-card>
  </div>
</template>

<script>
import { Errors } from 'form-backend-validation'
import { mapState, mapGetters } from 'vuex'
import PreviewPDF from './component/preview-pdf.vue'
import moment from 'moment'

export default {
  name: 'purchase-order-create',
  data() {
    return {
      model: {
        supplier_id: '',
        po_date: moment().format('DD-MM-YYYY'),
        preview: true,
        sub_item_list: []
      },
      errors: new Errors(),
      ready: false,
      saving: false,
      saving_new: false,
      newRow: {
        po_detail_id: 0,
        barcode: '',
        product_id: '',
        qty: 1,
        uom_id: ''
      }
    }
  },
  created() {
    this.fetDataBeforeCreate()
  },
  computed: {
    ...mapState('purchaseOrder', ['suppliers', 'products']),
    ...mapGetters('purchaseOrder', ['uomGetter'])
  },
  methods: {
    async fetDataBeforeCreate() {
      this.ready = true
      await this.$store.dispatch('purchaseOrder/dataBeforeCreate')
      this.ready = false
      this.$toasted.info('Ready! You can create your purchase order.')
    },
    addNewRow() {
      this.model.sub_item_list.push(_.clone(this.newRow))
    },
    removeRow(item) {
      this.model.sub_item_list.splice(this.model.sub_item_list.indexOf(item), 1)
    },
    barcodeChange(item) {
      if (!item.barcode) {
        item.product_id = ''
        item.uom_id = ''
        return
      }
      let result = this.products.filter(p => p.barcode == item.barcode)
      item.product_id = result[0].product_id
      item.uom_id = result[0].sale_code[0].uom_id
    },
    productChange(item) {
      if (!item.product_id) {
        item.product_id = ''
        item.uom_id = ''
        return
      }
      let result = this.products.filter(p => p.product_id == item.product_id)
      item.barcode = result[0].barcode
      item.uom_id = result[0].sale_code[0].uom_id
    },
    store() {
      this.errors = new Errors()
      this.saving = true
      this.$store
        .dispatch('purchaseOrder/store', this.model)
        .then(response => {
          this.saving = false
          this.$toasted.success(response.message)
          if (this.model.preview) {
            this.$modal.show(
              PreviewPDF,
              {
                url: response.url
              },
              {
                height: 'auto',
                width: '50%',
                scrollable: true,
                draggable: '.form-header',
                clickToClose: false
              },
              {
                'before-close': this.clearInput
              }
            )
          } else {
            this.$router.push({ name: 'purchase-order' })
          }
        })
        .catch(error => {
          this.saving = false
          this.$toasted.error(error.message)
          this.errors = new Errors(error.errors)
        })
    },
    saveNew() {
      this.errors = new Errors()
      this.saving_new = true
      this.$store
        .dispatch('purchaseOrder/store', this.model)
        .then(response => {
          this.saving_new = false
          this.$toasted.success(response.message)
          if (this.model.preview) {
            this.$modal.show(
              PreviewPDF,
              {
                url: response.url
              },
              {
                height: 'auto',
                width: '50%',
                scrollable: true,
                draggable: '.form-header',
                clickToClose: false
              },
              {
                'before-close': this.clearInput
              }
            )
          } else {
            this.clearInput()
          }
        })
        .catch(error => {
          this.saving_new = false
          this.$toasted.error(error.message)
          this.errors = new Errors(error.errors)
        })
    },
    clearInput() {
      this.model = {
        supplier_id: '',
        po_date: moment().format('DD-MM-YYYY'),
        sub_item_list: []
      }
    }
  },
  beforeRouteLeave(to, from, next) {
    this.$store.commit('purchaseOrder/RESET_STATE')
    next()
  }
}
</script>
<style lang="css" scoped>
table td {
	vertical-align : middle;
}
.only-border-bottom {
	border-top: none;
	border-left: none;
	border-right: none;
	outline: none;
}
.table > tbody > tr > td{
	padding-top: 5px !important;
	padding-bottom: 5px !important;
	border: none !important
}
</style>
